import { render, staticRenderFns } from "./countyNewspaper.vue?vue&type=template&id=2e4dcc47&scoped=true&"
import script from "./countyNewspaper.vue?vue&type=script&lang=js&"
export * from "./countyNewspaper.vue?vue&type=script&lang=js&"
import style0 from "./countyNewspaper.vue?vue&type=style&index=0&id=2e4dcc47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4dcc47",
  null
  
)

export default component.exports